<script setup>
import SearchWidget from '@/Components/Search/Widget.vue';
import LayoutSearch from '@/Layouts/Search.vue';
import ScholarshipListItem from '@/Components/List/Item/Scholarship.vue';
import PaginatedList from '@/Components/List/Paginated.vue';
import { ref, computed } from 'vue';
import Heading from '@/Components/Heading.vue';
import { Head, usePage } from '@inertiajs/vue3';

const props = defineProps({
  scholarships: {
    type: Object,
    required: true
  },
  queryObject: {
    type: Object,
    required: true
  }
});

const activeTab = ref('scholarships');

const page = usePage();

const context = computed(() => page.props?.context);
const providerName = context.value.name;
</script>

<template>
  <Head>
    <title>Search Scholarships - {{ providerName }}</title>
    <meta name="description" :content="`Scholarship Search Results - ${providerName}`">
  </Head>
  <LayoutSearch>
    <template #hero>
      <SearchWidget v-model="activeTab" :query-object="queryObject"/>
    </template>
    <template #content>
      <div v-if="activeTab != 'scholarships'">
        <div class="py-32">
          <Heading
            class="text-center"
            size="h2"
            style-size="h1"
          >
            Start searching {{ activeTab }}
          </Heading>
        </div>
      </div>
      <PaginatedList
        v-else
        slug="scholarships"
        list-name="scholarships"
        :current-page="scholarships.meta?.page ?? 1"
        :total-results="scholarships.meta?.total ?? 0"
        :query-object="queryObject"
      >
        <ScholarshipListItem
          v-for="scholarship, index in scholarships.data"
          :key="`scholarship-${index}`"
          :scholarship="scholarship"
        />
      </PaginatedList>
    </template>
  </LayoutSearch>
</template>

